import { seoUrlBetfeed } from '../../spa/Utils/SeoUrls';
import { betfeedUrl } from '../../spa/Utils/LocalizedUrls';

export const BB_BETFEED_CSS_CLASS_BLOCK_NAME = 'bb-betfeed';
export const I18N_PREFIX = 'betfeed';
export const BB_BETFEED_NO_RESULTS_TEXT = `${I18N_PREFIX}.betfeed_no_results`;
export const BB_BETFEED_NO_RESULTS_CLEAR_FILTERS_TEXT = `${I18N_PREFIX}.clear_filters`;
export const BB_BETFEED_CONTROLLER = '/betfeed_requests';
export const BB_BETFEED_ENDPOINT = `${BB_BETFEED_CONTROLLER}/betcards`;
export const BB_BETFEED_LAST_TIMESTAMP_ENDPOINT = `${BB_BETFEED_CONTROLLER}/getLastBetsTimestamp`;
export const BB_BETFEED_GET_BETABLE_SPORT_FILTER_ENDPOINT = `${BB_BETFEED_CONTROLLER}/getBetableSports`;

/**
 * This populates the 'bet_locate' key that is sent to the backend with the bet() call. Do not change this
 * without consulting with BE and Google Analytics users - it is used by both for reporting purposes.
 */
export const BB_BETFEED_GA_COMPONENT_NAME = 'betfeed_page';
export const BB_BETFEED_CSS_ID_PREFIX = 'js-Betfeed';
export const BB_BETFEED_ENABLED_STATE_KEY = 'betfeed:page:status';
export const BB_BETFEED_WIDGET_ENABLED_STATE_KEY = 'betfeed:widget:status';
export const BB_BETFEED_LOADING_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_CSS_CLASS_BLOCK_NAME}__loading`;
export const BB_BETFEED_LOADING_NEW_BETS_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_LOADING_CSS_CLASS_BLOCK_NAME}-new-bets`;
export const BB_BETFEED_LOADING_NEW_BETS_FIXED_CSS_CLASS_NAME = `${BB_BETFEED_LOADING_NEW_BETS_CSS_CLASS_BLOCK_NAME}-fixed`;
export const BB_BETFEED_LOADING_CONTAINER_CLASS = `${BB_BETFEED_LOADING_CSS_CLASS_BLOCK_NAME}--container`;
export const BB_BETFEED_LOADING_LOADING_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_LOADING_CSS_CLASS_BLOCK_NAME}--loading`;
export const BB_BETFEED_LOADING_LOADABLE_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_LOADING_CSS_CLASS_BLOCK_NAME}--loadable`;
export const BB_BETFEED_LOADING_LOADED_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_LOADING_CSS_CLASS_BLOCK_NAME}--loaded`;
export const BB_BETFEED_LOADING_ICON_CSS_CLASS_NAME = `${BB_BETFEED_LOADING_CSS_CLASS_BLOCK_NAME}-icon`;
export const BB_BETFEED_LOADING_TEXT_CSS_CLASS_NAME = `${BB_BETFEED_LOADING_CSS_CLASS_BLOCK_NAME}-text`;
export const BB_BETFEED_LOADING_NEW_BETS_TEXT = `${I18N_PREFIX}.new_bets`;

// if this change then QA test need to be changed
export const BB_BETFEED_NEW_BETS_TIME_DELAY_IN_MILLI_SECONDS = 10000; // 10 secs
export const BB_BETFEED_FILTER_DEBOUNCE = 500;
export const BB_BETFEED_FILTER_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_CSS_CLASS_BLOCK_NAME}__filter`;
export const BB_BETFEED_FILTER_CSS_CLASS_HEAD_NAME = `${BB_BETFEED_FILTER_CSS_CLASS_BLOCK_NAME}-head`;
export const BB_BETFEED_FILTER_CSS_CLASS_BODY_NAME = `${BB_BETFEED_FILTER_CSS_CLASS_BLOCK_NAME}-body`;
export const BB_BETFEED_FILTER_CSS_CLASS_BODY_FILTER_NAME = `${BB_BETFEED_FILTER_CSS_CLASS_BODY_NAME}-title`;
export const BB_BETFEED_FILTER_CSS_CLASS_YELLOW_TEXT = `${BB_BETFEED_FILTER_CSS_CLASS_HEAD_NAME}-text--yellow`;
export const BB_BETFEED_FILTER_ACTIVE_KEY = 'betfeed:filter:active';
export const BB_BETFEED_FILTER_SELECTED_KEY = 'betfeed:filter:selected';
export const BB_BETFEED_FILTER_QUERY_KEY = 'betfeed:filter:query';
export const BB_BETFEED_FILTER_MOST_RECENT = { id: 'most_recent', name: `${I18N_PREFIX}.most_recent` };
export const BB_BETFEED_FILTER_MOST_POPULAR = { id: 'most_popular', name: `${I18N_PREFIX}.most_popular` };
export const BB_BETFEED_FILTER_START_TIME = { id: 'start_time', name: `${I18N_PREFIX}.start_time` };
export const BB_BETFEED_FILTER_TYPE_SPORTS = { id: 'sports', name: `${I18N_PREFIX}.sports` };
export const BB_BETFEED_FILTER_TYPE_SORT_BY = { id: 'sortBy', name: `${I18N_PREFIX}.sort_by` };
export const BB_BETFEED_FILTER_TYPE_EVENT_STATUS = { id: 'eventStatus', name: `${I18N_PREFIX}.event_status` };
export const BB_BETFEED_FILTER_TYPE_BET_TYPE = { id: 'betType', name: `${I18N_PREFIX}.bet_type` };
export const BB_BETFEED_FILTER_BET_TYPES_DEFAULT = { id: 'all', name: `${I18N_PREFIX}.all` };

export const BB_BETFEED_FILTER_BET_TYPES_INTIALSTATE = {
    [BB_BETFEED_FILTER_TYPE_BET_TYPE.id]: {
        all: BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
        singles: { id: 'singles', name: `${I18N_PREFIX}.singles` },
        multi: { id: 'multi', name: `${I18N_PREFIX}.multiples` },
    },
    [BB_BETFEED_FILTER_TYPE_EVENT_STATUS.id]: {
        all: BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
        preplay: { id: 'preplay', name: `${I18N_PREFIX}.pre_event` },
        inplay: { id: 'inplay', name: `${I18N_PREFIX}.live` },
    },
};

export const BB_BETFEED_FILTER_SORT_BY_INITIALSTATE = {
    [BB_BETFEED_FILTER_MOST_RECENT.id]: { name: BB_BETFEED_FILTER_MOST_RECENT.name },
    [BB_BETFEED_FILTER_START_TIME.id]: { name: BB_BETFEED_FILTER_START_TIME.name },
    [BB_BETFEED_FILTER_MOST_POPULAR.id]: { name: BB_BETFEED_FILTER_MOST_POPULAR.name},
};

export const BB_BETFEED_FILTER_BOX_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_FILTER_CSS_CLASS_BLOCK_NAME}-box`;
export const BB_BETFEED_FILTER_BOX_BET_TYPE_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_FILTER_BOX_CSS_CLASS_BLOCK_NAME}-bet-type`;
export const BB_BETFEED_FILTER_BOX_CLEAR_FILTER_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_FILTER_BOX_CSS_CLASS_BLOCK_NAME}-clear-filters`;
export const BB_BETFEED_FILTER_BOX_CLEAR_FILTER_ICON_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_FILTER_BOX_CLEAR_FILTER_CSS_CLASS_BLOCK_NAME}-icon`;
export const BB_BETFEED_FILTER_BOX_CLEAR_FILTER_DISABLED_CSS_CLASS_NAME = `${BB_BETFEED_FILTER_BOX_CLEAR_FILTER_CSS_CLASS_BLOCK_NAME}--disabled`;
export const BB_BETFEED_FILTER_BOX_CELL_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_FILTER_BOX_CSS_CLASS_BLOCK_NAME}-cell`;
export const BB_BETFEED_FILTER_BOX_CELL_EMPTY_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_FILTER_BOX_CELL_CSS_CLASS_BLOCK_NAME}-empty`;
export const BB_BETFEED_FILTER_BOX_LABEL_BLOCK = `${BB_BETFEED_FILTER_CSS_CLASS_BLOCK_NAME}-label-box`;
export const BB_BETFEED_FILTER_BOX_ACTIVE_CSS_CLASS_NAME_IDENTIFIER = `${BB_BETFEED_FILTER_BOX_CSS_CLASS_BLOCK_NAME}--active`;
export const BB_BETFEED_FILTER_BOX_SELECTED_CSS_CLASS_NAME_IDENTIFIER = `${BB_BETFEED_FILTER_BOX_CSS_CLASS_BLOCK_NAME}--selected`;
export const BB_BETFEED_FILTER_BOX_BLANK_CELL_KEY_NAME = 'blank-cell';
export const BB_BETFEED_FILTER_BOX_SPORTS_CONTAINER_CLASS_NAME = `${BB_BETFEED_FILTER_CSS_CLASS_BLOCK_NAME}-sports-container`;
export const BB_BETFEED_FILTER_BOX_SPORT_ITEM_CLASS_NAME = `${BB_BETFEED_FILTER_CSS_CLASS_BLOCK_NAME}-sport-item`;
export const BB_BETFEED_FILTER_BOX_SPORT_COLUMNS_AMOUNT = 2;
export const BB_BETFEED_FILTER_BOX_SPORT_ITEM_HEIGHT = 40;
export const BB_BETFEED_NO_IE_CSS_CLASS_BLOCK_NAME = `${BB_BETFEED_CSS_CLASS_BLOCK_NAME}__no-ie`;
export const BB_BETFEED_NO_IE_TEXT = `${I18N_PREFIX}.betfeed_no_ie`;
export const BB_BETFEED_PULL_REFRESH_CSS_BLOCK_NAME = `${BB_BETFEED_CSS_CLASS_BLOCK_NAME}__pull-to-refresh`;
export const BB_BETFEED_PULL_REFRESH_DEFAULT_DISTANCE_THRESHOLD = 54;

export const BB_BETFEED_LOADING_STATES = {
    INIT: '',
    LOADABLE: 'loadable',
    LOADING: 'loading',
    LOADED: 'loaded',
};

export const BB_BETFEED_SPORT_FILTERS_TITLE_TEXT = `${I18N_PREFIX}.sports_a_z`;
export const BB_BETFEED_CLEAR_FILTERS_TEXT = `${I18N_PREFIX}.clear_filters`;
export const BB_BETFEED_WIDGET = 'c-widgetcontainer';
export const BB_BETFEED_WIDGET_FOOTER = `${BB_BETFEED_WIDGET}__footer`;
export const BB_BETFEED_WIDGET_BETFEED_URL = `${seoUrlBetfeed(betfeedUrl())}`;
export const BB_BETFEED_WIDGET_HEADER_TEXT_TITLE = `${I18N_PREFIX}.betfeed`;
export const BB_BETFEED_WIDGET_HEADER_SPORTS_TEXT_TITLE = `${I18N_PREFIX}.betfeed_sport`;
export const BB_BETFEED_WIDGET_FOOTER_SPORTS_TEXT_TITLE = `${I18N_PREFIX}.see_all_popular_[sport]_bets`;
export const BB_BETFEED_FOOTER_NAME = `${I18N_PREFIX}.betfeed_title`;
export const BB_BETFEED_FOOTER_TYPE = 'most_popular';
export const GTM_BETFEED_PAGE = 'betfeed';
export const POPULAR_BETS_PAGE = 'popular-bets-page';
export const GTM_BETFEED_SPORTS_FILTER = 'sports-filter';
export const GTM_BETFEED_BET_TYPE_FILTER = 'bet-type-filter';
export const GTM_BETFEED_SORT_BY_FILTER = 'sort-by-filter';
export const GTM_BETFEED_CLEAR_FILTERS = 'clear-filters';
export const GTM_BETFEED_FILTER_SUFFIX = '-filter';
export const GTM_BETFEED_BET_TYPE_FILTER_PREFIX = 'bet-type-';
export const GTM_BETFEED_EVENT_STATUS_FILTER_PREFIX = 'event-status-';
export const GTM_BETFEED_CLEAR_FILTER_NO_RESULTS = `${GTM_BETFEED_PAGE};clear-filters-no-results`;
export const GTM_BETFEED_SPLIT_FIRST = 1;

//INSTRUCTION CARD
export const I18N_INSTRUCTION_PREFIX = 'instruction_cards';
export const INSTRUCTION_CONTENT_MOBILE = `${I18N_INSTRUCTION_PREFIX}.betfeed_swipe`;
export const INSTRUCTION_CONTENT_WEB = `${I18N_INSTRUCTION_PREFIX}.betfeed_web`;
export const INSTRUCTION_CONTENT_PAGE = `${I18N_INSTRUCTION_PREFIX}.betfeed_page`;
export const INSTRUCTION_CONTENT_TITLE = `${I18N_INSTRUCTION_PREFIX}.betfeed_title`;
export const BETFEED_BET_CARD_GTM = 'bet-card';
